import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
	providedIn: 'root'
})
export class IsAuthenticatedGuard  {

	constructor(
		private readonly _router: Router,
		private readonly _authService: AuthService
	) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree
	{
		return this._authService.getUserProfile()
			.pipe(
				map((v) =>
				{
					if (!v.succeeded) {
						this._router.navigate(["/login"]);
					}
					return v.succeeded
				}),
				catchError((e) => {
					this._router.navigate(["/"]);
					return of(false);
				})
			);
	}
  
}
